import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { FadeUp, PageHero } from "../components/Reveal";

export default function News() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/news").then(({ data }) => setItems(data.items)).catch(() => {});
  }, []);

  return (
    <main data-testid="news-page">
      <PageHero eyebrow="Journal" title="News & stories from Peel" sub="Updates from the shop and the workshop — new pieces, collections and Celtic Gold stories." />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {items.map((art, i) => (
            <FadeUp key={art.slug} delay={(i % 3) * 0.08}>
              <Link to={`/news/${art.slug}`} className="group block" data-testid={`news-archive-${art.slug}`}>
                <div className="overflow-hidden border border-white/5 group-hover:border-gold/40 transition-colors duration-700 mb-5">
                  {art.image && <img src={art.image} alt={art.title} loading="lazy" className="w-full aspect-[16/10] object-cover transition-transform duration-[1.2s] group-hover:scale-110" />}
                </div>
                <p className="font-mono text-xs text-gold mb-2">
                  {new Date(art.published).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" })}
                </p>
                <h2 className="font-serif text-2xl text-ivory group-hover:text-gold transition-colors duration-300">{art.title}</h2>
                <p className="text-stone-mist text-sm font-light mt-3 line-clamp-3">{art.excerpt}</p>
              </Link>
            </FadeUp>
          ))}
        </div>
        {items.length === 0 && <p className="text-stone-mist text-center py-20">No articles yet — check back soon.</p>}
      </section>
    </main>
  );
}
